export const version = {
    major: 1,
    minor: 4,
    patch: 105
}
